import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  VisualizationType,
  chartTypeIdToVisualizationTypeMap,
} from 'src/app/core/models/widget.models';

import { LoggerService } from '@services/logger.service';
import { SafeHtml } from '@angular/platform-browser';
import { WidgetService } from 'src/app/core/services/widget.service';

type VisualizationMap = Map<string, string>;

@Component({
  selector: 'app-widget-visualization-type-card',
  templateUrl: './widget-visualization-type-card.component.html',
  styleUrls: ['./widget-visualization-type-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WidgetVisualizationTypeCardComponent
  implements OnInit, AfterViewInit
{
  @Input() chartId: number;
  @Input() chartTypeId: number;
  @Input() selected: boolean = false;
  @Input() width: number = 70;
  @Input() height: number = 70;
  @Input() dataSourceObjectId: string;
  @Input() dataSourceObjectClassId: number;

  visualizationType: VisualizationType;
  visualizationTypes: VisualizationMap;
  svgContent: SafeHtml;

  constructor(
    private widgetService: WidgetService,
    private logger: LoggerService,
  ) {
    this.visualizationTypes = new Map<VisualizationType, string>([
      [
        VisualizationType.AggregatedFunctions,
        'assets/img/charts/Aggregated-Functions.svg',
      ],
      [VisualizationType.AreaSpline, 'assets/img/charts/Area-Spline.svg'],
      [VisualizationType.Area, 'assets/img/charts/Area.svg'],
      [VisualizationType.Bar, 'assets/img/charts/Bar.svg'],
      [VisualizationType.Cloud, 'assets/img/charts/Cloud.svg'],
      [VisualizationType.Column, 'assets/img/charts/Column.svg'],
      [VisualizationType.GeoMap, 'assets/img/charts/Geo-Map.svg'],
      [VisualizationType.Heatmap, 'assets/img/charts/Heatmap.svg'],
      [VisualizationType.Line, 'assets/img/charts/Line.svg'],
      [VisualizationType.SentimentAverage, 'assets/img/charts/Area.svg'],
      [VisualizationType.Pie, 'assets/img/charts/Pie.svg'],
      [VisualizationType.Spline, 'assets/img/charts/Spline.svg'],
      [VisualizationType.Summary, 'assets/img/charts/Summary.svg'],
      [VisualizationType.Table, 'assets/img/charts/Table.svg'],
      [VisualizationType.PostList, 'assets/img/charts/Post-List.svg'],
      [
        VisualizationType.UserDefinedVariables,
        'assets/img/charts/User-Defined-Variables.svg',
      ],
      [VisualizationType.Html, 'assets/img/charts/Table.svg'],
      [VisualizationType.Section, 'assets/img/charts/Section.svg'],
    ]);
  }

  ngAfterViewInit() {}

  ngOnInit() {
    if (this.chartTypeId > 0) {
      this.visualizationType = chartTypeIdToVisualizationTypeMap.get(
        this.chartTypeId,
      );
    } else {
      this.logger.debug(
        'WidgetVisualizationTypeCardComponent: chartTypeId is not valid, defaulting to Html',
      );
      this.visualizationType = VisualizationType.Html;
    }

    this.loadSvg();
  }

  onDragStart(event: DragEvent) {
    if (!this.chartId || !this.chartTypeId) {
      event.preventDefault();
      return;
    }

    const dragData = {
      chartId: this.chartId,
      chartTypeId: this.chartTypeId,
      type: 'widget-visualization-type',
      dataSourceObjectId: this.dataSourceObjectId,
      dataSourceObjectClassId: this.dataSourceObjectClassId,
    };

    event.dataTransfer?.setData('application/json', JSON.stringify(dragData));
    event.dataTransfer!.effectAllowed = 'copy';
  }

  loadSvg() {
    const svgPath = this.visualizationTypes.get(this.visualizationType);
    if (!svgPath) {
      //this.logger.error('SVG path is undefined for visualization type:', this.visualizationType);
      return;
    }
    this.widgetService
      .getSvgContent(svgPath, this.width, this.height)
      ?.subscribe((svgContent) => {
        this.svgContent = svgContent;
      });
  }
}
